import moment from 'moment-jalaali';

export function toEnNum($number) {
	let FA = '۱۲۳۴۵۶۷۸۹۰';
	let AR = '١٢٣٤٥٦٧٨٩٠';
	let EN = '1234567890';
	if ($number)
		for (let i = 0; i < $number.length; i++) {
			for (let j = 0; j < FA.length; j++) {
				$number = $number.replace(FA[j], EN[j]); //FA->EN
				$number = $number.replace(AR[j], EN[j]); //AR->EN
			}
		}
	return $number;
}

export function codeMelliRegex(input) {
	if (!/^\d{10}$/.test(input)) return false;

	const check = +input[9];
	const sum =
		Array(9)
			.fill()
			.map((_, i) => +input[i] * (10 - i))
			.reduce((x, y) => x + y) % 11;
	return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
}

export function commafy(num) {
	if (num === null || num === undefined) return;
	var str = num.toString().split('.');
	if (str[0].length >= 5) {
		str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
	}
	if (str[1] && str[1].length >= 5) {
		str[1] = str[1].replace(/(\d{3})/g, '$1 ');
	}
	return str.join('.');
}

export function persianCharacterDateyear(date, format) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	return moment(date, format).format('HH:mm:ss jDD jMMMM  jYYYY ');
}

export function persianCharacterDate(date) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	return moment(date).format('jYYYY/jMM/jDD HH:mm');
}

export function persianDateَyearDay(date) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	return moment(date).format(' jDD jMMMM  jYYYY  ');
}

export function persianCharacterDateَ(date) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	return moment(date).format('  jMMMM  jYYYY ');
}

export function nextMonthCharacterDate(date) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	return moment(date).add(1, 'jm').format('  jMMMM  jYYYY ');
}

export function persianDateَ(date) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	return moment(date).format(' HH:mm -  jDD /jMM /jYYYY  ');
}

export function getMonthName(date) {
	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
	let monthNumber = moment(date, 'jM');
	return moment(monthNumber).format('jMMMM');
}

export function endOfCurrentMonth() {
	let m = new Date();
	return moment(m).endOf('jMonth').format(' jDD jMMMM  jYYYY  ');
}

export const toBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

export function customeDate(count, isToday, increaseDays) {
	// const getCurrentMon = moment().endOf('month').format('jM');

	moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });

	const nextMonths = Array(count || 6)
		.fill('')
		.map((_, index) => {
			const d = moment()
				.add(index + increaseDays, 'jm')
				.format('jYYYY/jM/jD');

			const withName = moment()
				.add(index + increaseDays, 'jm')
				.format('jMMMM');

			const year = moment()
				.add(index + increaseDays, 'jm')
				.format('jYYYY');

			const day = moment()
				.add(index + increaseDays, 'jd')
				.format('jD');

			return {
				date: d,
				month: withName,
				year,
				day,
			};
		});

	const currentDate = moment().format('jMMMM');
	const perviousDate = moment().add(-1, 'jm').format('jMMMM');
	const nextDate = moment().add(1, 'jm').format('jMMMM');
	const nextDate2 = moment().add(2, 'jm').format('jMMMM');

	if (isToday)
		return {
			current: currentDate,
			pervious: perviousDate,
			next: nextDate,
			next2: nextDate2,
		};

	return nextMonths;
}

function getUserToken(configAPIs) {
	let resultToken = configAPIs.getState()?.login?.token;

	return `Bearer ${resultToken}`;
}

export { getUserToken };
